import {
  MessageBox,
  Button
} from 'element-ui'

// Button 添加全局配置
Button.props.type = String
Button.props.plain = {
  type: Boolean,
  default: undefined
}

Button.config = {}

Button.setDefaults = function (config) {
  Object.assign(Button.config, config)
  MessageBox.setDefaults()
}

const getButtonText = function (slots) {
  for(const slot of slots) {
    if (!slot.componentInstance && slot.text) {
      return slot.text.replace(/\s/g,'')
    } else if (slot.children) {
      return getButtonText(slot.children)
    } else if (slot.componentInstance) {
      return getButtonText(slot.componentInstance.$slots)
    } else {
      return ''
    }
  }
}

const getConfig = function (vm) {
  const text = vm.$slots.default ? getButtonText(vm.$slots.default) : ''
  const config = vm.$options.config[text.trim()] || vm.$options.config['default'] || {}
  const type = vm.type || config.type || 'default'

  return {
    type,
    plain: typeof vm.plain !== 'undefined' ? vm.plain : type !== 'text' && config.plain
  }
}

const buttonOldRender = Button.render

Button.render = function (h) {
  const vnode = buttonOldRender.call(this)
  const config = getConfig(this)

  vnode.data.class[0] = `el-button--${config.type}`
  vnode.data.class[2]['is-plain'] = config.plain

  return vnode
}
